import React, { createContext, useState, useEffect } from 'react';
import AuthService from '../services/AuthService';
import { api } from '../utils/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
        const [isAuthenticated, setIsAuthenticated] = useState(false);
        const [user, setUser] = useState(null);
        const [authError, setAuthError] = useState(null);
        const [isLoading, setIsLoading] = useState(true);

        useEffect(() => {
                const checkAuthAndFetchUser = async () => {
                        try {
                                const authenticated = await AuthService.checkAuth();
                                if (authenticated) {
                                        const userRes = await api('/me');
                                        if (!userRes.ok) {
                                                throw new Error("Failed to fetch user data");
                                        }
                                        const userData = await userRes.json();
                                        setUser({
                                                customerName: userData.data.customer.name,
                                                customerId: userData.data.customer.id,
                                                email: userData.data.email,
                                                roleId: userData.data.role?.id,
                                                firstName: userData.data.first_name || '',
                                                lastName: userData.data.last_name || ''
                                        });
                                        setIsAuthenticated(true);
                                        setAuthError(null);
                                } else {
                                        setIsAuthenticated(false);
                                        setUser(null);
                                }
                        } catch (err) {
                                console.error(err);
                                setAuthError(err.message);
                                setIsAuthenticated(false);
                                setUser(null);
                        } finally {
                                setIsLoading(false);
                        }
                };
                checkAuthAndFetchUser();
        }, []);

        const login = async (username, password) => {
                setAuthError(null);
                try {
                        await AuthService.login(username, password);
                        // Fetch user data after successful login
                        const userRes = await api('/me');
                        if (!userRes.ok) {
                                throw new Error("Failed to fetch user data");
                        }
                        const userData = await userRes.json();
                        setUser({
                                customerName: userData.data.customer.name,
                                customerId: userData.data.customer.id,
                                email: userData.data.email,
                                roleId: userData.data.role?.id,
                                firstName: userData.data.first_name || '',
                                lastName: userData.data.last_name || ''
                        });
                        setIsAuthenticated(true);
                } catch (err) {
                        setAuthError(err.message);
                        throw err;
                }
        };

        const logout = async () => {
                await AuthService.logout();
                setIsAuthenticated(false);
                setUser(null);
                setAuthError(null);
        };

        const updateUser = (updates) => {
                setUser(prev => ({ ...prev, ...updates }));
        };

        return (
                <AuthContext.Provider value={{ isAuthenticated, user, login, logout, updateUser, authError, isLoading }}>
                        {children}
                </AuthContext.Provider>
        );
};
